module.exports = __webpack_public_path__ + "static/media/Illus-Nutrition_1@2x.dccfaeca.png";